module.exports = __webpack_public_path__ + "img/in-progress-policies.1f78ae51.png";